import React from 'react';
import {
  IconFileTypePdf,
  IconFileTypeXls,
  IconFileTypeCsv,
  IconFileTypeTxt,
  IconFileTypeDoc,
  IconFileTypeDocx,
  IconFileTypeZip,
  IconPhoto,
} from '@tabler/icons-react';

/**
 * Gets the appropriate file type icon component based on file extension
 * @param fileName - The name of the file (with or without path)
 * @returns React component for the file type icon
 */
export const getFileIcon = (fileName: string): React.ReactElement => {
  const extension = fileName.toLowerCase().split('.').pop() || '';

  switch (extension) {
    case 'pdf':
      return <IconFileTypePdf />;
    case 'xls':
    case 'xlsx':
    case 'xlsm':
    case 'xlsb':
      return <IconFileTypeXls />;
    case 'csv':
      return <IconFileTypeCsv />;
    case 'txt':
      return <IconFileTypeTxt />;
    case 'doc':
      return <IconFileTypeDoc />;
    case 'docx':
      return <IconFileTypeDocx />;
    case 'zip':
      return <IconFileTypeZip />;
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'tiff':
    case 'tif':
      return <IconPhoto />;
    default:
      return <IconFileTypePdf />; // Default to PDF icon
  }
};
